import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";

export default {
    storageKey: StorageKey.report_delivery_order_by_customer,
    getReportLabel: () => t`Delivery Orders by Customer`,
    getColumns: () => [],
};
